import React, { useCallback, useEffect } from 'react';
import classNames from 'classnames';
import QaseNavbar from './components/navbar/Navbar';
import SidebarComponent from './components/vertical-menu';
import menuData from '../configs/navigation';
import { useDispatch, useSelector } from 'react-redux';
import { getLayout, getUserSource } from '../redux/selectors';

import {
    handleMenuCollapsed,
    handleReferralFlagged,
} from '../redux/actions/layoutActions';
import ReferralRepository from '../repositories/ReferralRepository';
import UserRepository from '../repositories/UserRepository';

const LoggedLayout = (props) => {
    //console.log(props);
    // ** Store Vars
    const { roles, meta } = props;
    const dispatch = useDispatch();
    const layoutStore = useSelector(getLayout);
    const sourceId = useSelector(getUserSource);

    const activeRole = !!roles ? roles[0].name : null;
    // ** Vars
    const menuCollapsed = layoutStore.menuCollapsed;

    // ** Toggles Menu Collapsed
    const setMenuCollapsed = (val) => {
        dispatch(handleMenuCollapsed(val));
    };

    const checkFlagged = useCallback(
        async (status, payload) => {
            const result = await ReferralRepository.checkFlaggedReferral(
                status,
                payload,
            );

            dispatch(
                handleReferralFlagged({
                    key: status,
                    value: result.data.data,
                }),
            );
        },
        [dispatch],
    );

    useEffect(() => {
        (async () => {
            await UserRepository.getProfile();
        })();
    }, []);

    useEffect(() => {
        checkFlagged('Declined', { sourceId: sourceId });
    }, [sourceId, checkFlagged]);

    // ** Clean Up Function
    const cleanUp = useCallback(() => {
        if (meta) {
            if (meta.menuCollapsed) {
                dispatch(handleMenuCollapsed(!meta.menuCollapsed));
            }
        }
    }, [meta, dispatch]);

    // ** ComponentDidMount
    useEffect(() => {
        if (meta) {
            if (meta.menuCollapsed) {
                dispatch(handleMenuCollapsed(meta.menuCollapsed));
            }

            if (
                !!roles &&
                (roles[0].name === 'Lawyer' || roles[0].name === 'Agent')
            ) {
                dispatch(handleMenuCollapsed(true));
            }
        }
        return () => cleanUp();
    }, [roles, dispatch, meta, cleanUp]);

    return (
        <div
            className={classNames('wrapper navbar-sticky vertical-layout', {
                'menu-collapsed':
                    menuCollapsed === true && activeRole !== 'Client',
                'partial-collapsed':
                    activeRole === 'Lawyer' || activeRole === 'Agent',
            })}
        >
            {activeRole !== 'Client' && (
                <SidebarComponent
                    skin="dark"
                    menuData={menuData}
                    //routerProps={routerProps}
                    menuCollapsed={menuCollapsed}
                    menuVisibility={false}
                    setMenuCollapsed={setMenuCollapsed}
                    setMenuVisibility={() => {}}
                    currentActiveItem={props.currentActiveItem}
                    topSpace={
                        activeRole === 'Lawyer' ||
                        activeRole === 'Client' ||
                        activeRole === 'Agent'
                    }
                />
            )}
            <div
                className={classNames('app-content content', {
                    'has-sidebar': activeRole !== 'Client',
                })}
            >
                <QaseNavbar
                    leftSpace={
                        !(
                            activeRole === 'Lawyer' ||
                            activeRole === 'Client' ||
                            activeRole === 'Agent'
                        )
                    }
                />

                <div className="content-wrapper">{props.children}</div>
            </div>
        </div>
    );
};

export default LoggedLayout;
